var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval62DError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M6 52.147v-4.853h10v3.534a2.5 2.5 0 0 1-2.9 2.468L6 52.147ZM6 6.853v4.853h10V8.172a2.5 2.5 0 0 0-2.9-2.468L6 6.853ZM6 47.294V11.706h10v35.588H6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f39898",
  fillRule: "evenodd",
  d: "M6 4.235a1 1 0 0 1 1 1v48.53a1 1 0 1 1-2 0V5.235a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M54 6.853v4.853H44V8.172a2.5 2.5 0 0 1 2.9-2.468L54 6.853ZM54 52.147v-4.853H44v3.534a2.5 2.5 0 0 0 2.9 2.468l7.1-1.149ZM54 11.706v35.588H44V11.706h10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#f39898",
  fillRule: "evenodd",
  d: "M54 54.765a1 1 0 0 1-1-1V5.235a1 1 0 1 1 2 0v48.53a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20 12c0-5.523 4.477-10 10-10s10 4.477 10 10v36c0 5.523-4.477 10-10 10s-10-4.477-10-10V12Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f39898",
  fillRule: "evenodd",
  d: "M38 48V12a8 8 0 1 0-16 0v36a8 8 0 1 0 16 0ZM30 2c-5.523 0-10 4.477-10 10v36c0 5.523 4.477 10 10 10s10-4.477 10-10V12c0-5.523-4.477-10-10-10Z",
  clipRule: "evenodd"
})));
SvgOval62DError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval62DError);
export default ForwardRef;